export const copyToClipboard = (url: string) => {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(url);
  }
  // text area method
  const textArea = document.createElement('textarea');
  textArea.value = url;
  // make the textarea out of viewport
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  return new Promise<void>((res, rej) => {
    // here the magic happens
    // eslint-disable-next-line no-unused-expressions
    document.execCommand('copy') ? res() : rej(new Error('Cannot copy to clipload'));
    textArea.remove();
  });
};

/**
 * Gets random int
 * @param min
 * @param max
 * @returns random int - min & max inclusive
 */
export const getRandomInt = (min?: number, max?: number): number => {
  const minInt = min ? Math.ceil(min) : 0;
  const maxInt = max ? Math.floor(max) : Number.MAX_SAFE_INTEGER;
  return Math.floor(Math.random() * (maxInt - minInt + 1)) + minInt;
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

let isLocalDev: boolean | undefined;
export const getIsLocalDev = () => {
  if (isLocalDev !== undefined) {
    return isLocalDev;
  }

  if (typeof window === 'undefined' || !window) {
    return false;
  }
  const { hostname } = window.location;
  isLocalDev = hostname === '0.0.0.0' || hostname === 'localhost' || hostname.includes('192.168.0.');
  return isLocalDev;
};

let isStorageAvailable: boolean | undefined;
export const getIsStorageAvailable = () => {
  if (isStorageAvailable !== undefined) {
    return isStorageAvailable;
  }
  const test = '@vestico/storage-test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

// sqkipcq JS-0057
export const noopFunction = () => {
  // do nothing
};

// sqkipcq JS-0057
export const noopFunctionAsync = async () => {
  // do nothing
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getObjectKeys<T extends Record<string, any>>(object: T) {
  return Object.keys(object) as (keyof T)[];
}
